var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useCallback, useEffect, useMemo } from 'react';
import { useSchemaItems } from './schema';
export var useSubnav = function (_a) {
    var hostServices = _a.hostServices, orderedSchema = _a.orderedSchema, isSchemaItemHidden = _a.isSchemaItemHidden, granularOrder = _a.granularOrder;
    var featureFlags = hostServices.featureFlags, hostData = hostServices.hostData, session = hostServices.session, subnav = hostServices.subnav;
    var _b = useSchemaItems({ hostServices: hostServices }), isBankDown = _b.isBankDown, isInvestDown = _b.isInvestDown, isWealthDown = _b.isWealthDown, getDeposits = _b.getDeposits, getWealthOverview = _b.getWealthOverview, getInvestments = _b.getInvestments, getTransfers = _b.getTransfers, getPayments = _b.getPayments, getManageCDs = _b.getManageCDs, getManageIRAs = _b.getManageIRAs, getDocuments = _b.getDocuments, getTaxForms = _b.getTaxForms, ServiceDownModal = _b.ServiceDownModal;
    var areServicesDown = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_afg-accounts', false)) ? isBankDown && isInvestDown && isWealthDown
        : isBankDown && isInvestDown;
    var isSessionDataLoaded = !!session.data;
    var isAccountsLoaded = hostData.accounts.status.loadState === 'loaded';
    var areFeatureFlagsLoaded = featureFlags.loadState === 'loaded';
    var isLoaded = isSessionDataLoaded && isAccountsLoaded && areFeatureFlagsLoaded;
    var getOrderedSchema = function () {
        var schema = [];
        orderedSchema.forEach(function (item) {
            if (typeof item === 'string') {
                switch (item) {
                    case 'transfers':
                        schema.push.apply(schema, __spread(getTransfers()));
                        break;
                    case 'payments':
                        schema.push.apply(schema, __spread(getPayments()));
                        break;
                    case 'wealthOverview':
                        schema.push.apply(schema, __spread(getWealthOverview()));
                        break;
                    case 'investments':
                        schema.push.apply(schema, __spread(getInvestments()));
                        break;
                    case 'deposits':
                        schema.push.apply(schema, __spread(getDeposits()));
                        break;
                    case 'manageCDs':
                        schema.push.apply(schema, __spread(getManageCDs()));
                        break;
                    case 'manageIRAs':
                        schema.push.apply(schema, __spread(getManageIRAs()));
                        break;
                    case 'documents':
                    case 'statements':
                        schema.push.apply(schema, __spread(getDocuments()));
                        break;
                    case 'taxForms':
                        schema.push.apply(schema, __spread(getTaxForms()));
                        break;
                    default:
                    // do nothing
                }
            }
            else if (Array.isArray(item)) {
                schema.push.apply(schema, __spread(item));
            }
        });
        return schema;
    };
    var getDefaultSchema = function () {
        return __spread(getTransfers(), getPayments(), getWealthOverview(), getInvestments(), getDeposits(), getManageCDs(), getManageIRAs(), getDocuments(), getTaxForms());
    };
    var derivedSchemaItems = useMemo(function () {
        // isLoaded is not used here, but we need to update the schema when
        // all of the user session and account data becomes available.
        return orderedSchema ? getOrderedSchema() : getDefaultSchema();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderedSchema, isLoaded]);
    var schemaItemsFilter = useCallback(function (items) {
        return items.reduce(function reducer(filteredItems, item) {
            if (!(isSchemaItemHidden === null || isSchemaItemHidden === void 0 ? void 0 : isSchemaItemHidden(item))) {
                if (item.type === 'menu' && item.items.length) {
                    var subItems = item.items.reduce(reducer, []);
                    // if the dropdown menu does not have any sub items, do not
                    // render the dropdown menu.
                    if (subItems.length) {
                        filteredItems.push(__assign(__assign({}, item), { items: subItems }));
                    }
                }
                else {
                    filteredItems.push(item);
                }
            }
            return filteredItems;
        }, []);
    }, [isSchemaItemHidden]);
    useEffect(function () {
        if (isLoaded) {
            var appSchema = new subnav.Schema(subnav.schema, granularOrder || undefined);
            var appSchemaItems = areServicesDown ? [] : derivedSchemaItems;
            appSchema.set(schemaItemsFilter(appSchemaItems));
            subnav.set(appSchema.schema);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded]);
    return { ServiceDownModal: ServiceDownModal };
};
//# sourceMappingURL=useSubnav.js.map